import { render } from "./TherapyBundlePurchaseManagement.vue?vue&type=template&id=27ec389d&scoped=true"
import script from "./TherapyBundlePurchaseManagement.vue?vue&type=script&lang=js"
export * from "./TherapyBundlePurchaseManagement.vue?vue&type=script&lang=js"

import "./TherapyBundlePurchaseManagement.vue?vue&type=style&index=0&id=27ec389d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ec389d"]])

export default __exports__